export const Routes = {
  LOGIN_EUA: "/institutions/:region/:locale/login",
  LOGOUT_EUA: "/institutions/:region/:locale/logout",
  LOGIN_NA: "/institutional/login",
  LOGOUT_NA: "/institutional/logout",
} as const;

export type Route = (typeof Routes)[keyof typeof Routes];

export const ACC_TOKEN = "accessToken";
export const ACTIVE = "Active";
export const EMAILNOTCONFIRMED = "EmailNotConfirmed";
export const FINANCIAL = "financial";
export const INSTITUTIONAL = "institutional";
export const INSTITUTIONS = "institutions";
export const LOCKEDOUT = "LockedOut";
export const PASSWORDRECOVERY = "PasswordRecovery";
export const REMEMBER_ME = "RememberMe";
export const REMEMBER_ME_FLAG = "RemFlag";
export const REVOKED = "Revoked";
export const STEP_1_INSTITUTIONAL_SITE_LOGIN =
  "Step 1: Institutional Site Login";
export const LOGIN_PAGE_NAME = "Login";
export const TNC_TENANT = "NACG";
export const LOCAL_ACCEPTED_TNCS = "DAC_TNC_acceptedVersions";
